/*
|--------------------------------------------------------------------------
| Wellgard Recommendation Engine
|--------------------------------------------------------------------------
| products.js
|--------------------------------------------------------------------------
*/

window.Wellgard = window.Wellgard || {};


window.Wellgard.Constants = {

    AGE: {
        AGE_50_PLUS: "50+"
    },

    GENDER: {
        MALE: "Male",
        FEMALE: "Female",
        PREFER_NOT_TO_SAY: "Prefer not to say"
    },

    DIET: {
        VEGAN: "Vegan",
        VEGETARIAN: "Vegetarian",
        HALAL: "Halal",
        KOSHER: "Kosher",
        PESCATARIAN: "Pescatarian"
    },

    SYMPTOMS: {
        CONSTIPATED: "I'm constipated",
        JUST_OFF_ANTIBIOTICS: "I just got off antibiotics and my tummy doesn't feel good"
    }

};


window.Wellgard.Products = {

    "15254061613435": {
        id: 15254061613435,       
        title: "14 Day Gut Ritual",
        handle: "14-day-gut-ritual",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: [],
        primary: ["Better Digestion"],
        secondary: [
            "Healthy Joints",
            "Less Stress",
            "More Energy",
            "Staying Focussed"
        ],
        special: null
    },

    "15335744766331": {
        id: 15335744766331,
        title: "ACV & Ginger Gummies",
        handle:"fiery-acv-ginger-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["Better Digestion"],
        secondary: [
            "Healthy Joints",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity"
        ],
        special: null
    },

    "6013421453489": {
        id: 6013421453489,
        title: "Apple Cider Vinegar Gummies",
        handle:"vegan-apple-cider-vinegar-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["Better Digestion"],
        secondary: [
            "Healthy Joints",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity"
        ],
        special: null
    },

    "8238375633128": {
        id: 8238375633128,
        title: "Ashwagandha Gummies",
        handle:"vegan-ashwaghanda-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["Less Stress"],
        secondary: [
            "Better Sleep",
            "Hormonal Health",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity"
        ],
        special: null
    },

    "14680374968699": {
        id: 14680374968699,
        title: "Astashield Astaxanthin Capsules",
        handle:"astashield-with-8mg-of-natural-astaxanthin",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["Healthy Skin"],
        secondary: [
            "Healthy Joints",
            "Stronger Immunity"
        ],
        special: null
    },

    "15048864268667": {
        id: 15048864268667,
        title: "Berbenite Berberine Capsules",
        handle:"berberine",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [],
        secondary: [
            "Beautiful Hair",
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "15385057329531": {
        id: 15385057329531,
        title: "Beta NMN Capsules",
        handle:"beta-nmn-resveratrol-nicotinamide-complex",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: [],
        primary: [
            "More Energy"
        ],
        secondary: [
            "Healthy Skin",
            "Less Stress",
            "Staying Focussed"
        ],
        special: null
    },

    "8066375221480": {
        id: 8066375221480,
        title: "Biohair Biotin Gummies",
        handle:"vegan-biohair-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "Beautiful Hair",
            "Stronger Nails"
        ],
        secondary: [
            "Healthy Skin",
            "Less Stress",
            "More Energy",
            "Staying Focussed"
        ],
        special: null
    },

    "7518995742952": {
        id: 7518995742952,
        title: "Bioskin Skin Gummies",
        handle:"skin-hair-and-nails-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "Healthy Skin"
        ],
        secondary: [
            "Beautiful Hair",
            "Healthy Joints",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "8131902963944": {
        id: 8131902963944,
        title: "Calcium Gummies",
        handle:"vegan-calcium-vitamin-d3-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "Healthy Joints"
        ],
        secondary: [
            "Better Digestion",
            "Less Stress",
            "More Energy",
            "Stronger Immunity"
        ],
        special: null
    },

    "8286398382312": {
        id: 8286398382312,
        title: "Cherryaid Tart Cherry",
        handle:"tart-cherry-concentrate",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "Better Sleep"
        ],
        secondary: [
            "Healthy Joints",
            "Less Stress"
        ],
        special: {             
            stress: "trouble sleeping",
            score: 1
        }
    },

    "8078598766824": {
        id: 8078598766824,
        title: "Cherryaid Sour Cherry",
        handle:"cherryaid",
        active: true,    
        includeInQuiz: false,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "Better Sleep"
        ],
        secondary: [
            "Healthy Joints",
            "Less Stress"
        ],        
        special: {             
            stress: "trouble sleeping",
            score: 1
        }
    },

    "8447251775720": {
        id: 8447251775720,
        title: "Colostrum Powder",
        handle:"colostrum-powder",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: [],
        primary: [
            "Stronger Immunity"
        ],
        secondary: [],
        special: null
    },

    "14907178746235": {
        id: 14907178746235,
        title: "ElectroMight Daily Electrolytes",
        handle:"electromight-sugar-free-electrolyte-drink",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: [],
        primary: [
            "More Energy"
        ],
        secondary: [
            "Beautiful Hair",
            "Better Digestion",
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "15367721025915": {
        id: 15367721025915,
        title: "ElectroMight Intense Electrolytes",
        handle:"electromight-intense-electrolytes",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: [],
        primary: [
            "More Energy"
        ],
        secondary: [
            "Beautiful Hair",
            "Better Digestion",
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },
    "15155809091963": {
        id: 15155809091963,
        title: "Fleur Women's Formula",
        handle:"libido-booster-for-women",
        active: true,    
        includeInQuiz: true,
        gender: "Female",
        exclude: "Male",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["Hormonal Health"],
        secondary: [
            "Healthy Joints",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity"
        ],
        special: null
    },

    "14861644497275": {
        id: 14861644497275,
        title: "Fortified Kombucha Powder",
        handle:"fortified-kombucha",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: [],
        primary: ["Better Digestion"],
        secondary: [
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity"
        ],
        special: null
    },

    "8608633716968": {
        id: 8608633716968,
        title: "Gutstar Gut Probiotics",
        handle:"gutstar-probiotics-for-gut-health",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["Better Digestion"],
        secondary: [
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity"
        ],
        special: {             
            digestion: window.Wellgard.Constants.SYMPTOMS.JUST_OFF_ANTIBIOTICS,          
            score: 10
        }
    },

    "6973490757809": {
        id: 6973490757809,
        title: "Halal Collagen Powder",
        handle:"halal-collagen-powder",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Halal"],
        primary: ["Healthy Skin","Beautiful Hair", "Stronger Nails"],
        secondary: [],
        special: {
            featured:'true',
            score: 10
        },

    },

    "8636337815784": {
        id: 8636337815784,
        title: "High Fibre Gummies",
        handle:"high-strength-fibre-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["Better Digestion"],
        secondary: [
            "Beautiful Hair",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "15284189757819": {
        id: 15284189757819,
        title: "Lean Pump Pre-Workout",
        handle:"lean-pump-pre-workout",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: [],
        primary: [],
        secondary: [
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity"
        ],
        special: null
    },

    "15320685871483": {
        id: 15320685871483,
        title: "Lemrise Greens",
        handle:"lemrise",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: [],
        primary: ["General Wellbeing"],
        secondary: [
            "Beautiful Hair",
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "15306451353979": {
        id: 15306451353979,
        title: "Lion's Mane Gummies",
        handle:"lions-mane-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["Staying Focussed"],
        secondary: [
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "More Energy"
        ],
        special: null
    },

    "8288749486312": {
        id: 8288749486312,
        title: "Mag 1200 Magnesium Glycinate",
        handle:"mag-1200-magnesium-bisglycinate",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["Less Stress"],
        secondary: [
            "Better Sleep",
            "Healthy Joints",
            "More Energy",
            "Staying Focussed"
        ],
        special: null
    },

    "14830822654331": {
        id: 14830822654331,
        title: "Manefocus Capsules",
        handle:"manefocus-for-brain-memory-focus",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["Staying Focussed"],
        secondary: [
            "Hormonal Health",
            "Less Stress",
            "More Energy"
        ],
        special: null
    },

    "15253077131643": {
        id: 15253077131643,
        title: "Mellow Moon Period Sachets",
        handle:"mellow-moon-period-comfort",
        active: true,    
        includeInQuiz: true,
        gender: "Female",
        exclude: "Male",
        audience: "Adults",
        diet: [],
        primary: ["Hormonal Health"],
        secondary: [
            "Beautiful Hair",
            "Healthy Joints",
            "Healthy Skin",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "8899623813352": {
        id: 8899623813352,
        title: "Micro Greens Powder",
        handle:"micro-super-greens",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["General Wellbeing"],
        secondary: [
            "Beautiful Hair",
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "14908819407227": {
        id: 14908819407227,
        title: "Moringa Complex Capsules",
        handle:"max-moringa-rosa",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["General Wellbeing"],
        secondary: [
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity"
        ],
        special: null
    },

    "14835542393211": {
        id: 14835542393211,
        title: "My Journey Multivitamin",
        handle:"my-journey",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["General Wellbeing"],
        secondary: [
            "Beautiful Hair",
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "15402251747707": {
        id: 15402251747707,
        title: "Night Snooze Sleep Powder",
        handle:"night-snooze-sleep-support",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: [],
        primary: ["Better Sleep"],
        secondary: [
            "Healthy Joints",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed"
        ],
        special: {             
            stress: "trouble sleeping",
            score: 1
        }
    },

    "15069540614523": {
        id: 15069540614523,
        title: "Nitrabeets Beetroot Capsules",
        handle:"nitrabeet-beetroot-supplement-with-nitrates",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["More Energy"],
        secondary: [
            "Healthy Joints",
            "Less Stress",
            "Staying Focussed"
        ],
        special: null
    },

    "8152858624232": {
        id: 8152858624232,
        title: "Omega 3 Gummies",
        handle:"vegan-omega-3-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["General Wellbeing"],
        secondary: [
            "Healthy Joints",
            "Healthy Skin",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity"
        ],
        special: null
    },

    "14878737727867": {
        id: 14878737727867,
        title: "Optiglut Glutathione Capsules",
        handle:"optiglut-liposomal-glutathione-gsh",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["Healthy Skin"],
        secondary: [],
        special: null
    },

    "15265112359291": {
        id: 15265112359291,
        title: "Ovicos PCOS Sachets",
        handle:"ovicos-womens-pcos-supplement",
        active: true,    
        includeInQuiz: true,
        gender: "Female",
        exclude: "Male",
        audience: "Adults",
        diet: [],
        primary: ["Hormonal Health"],
        secondary: [
            "Beautiful Hair",
            "Healthy Joints",
            "Healthy Skin",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "15074808070523": {
        id: 15074808070523,
        title: "Peach Perfect Powder",
        handle:"peach-perfect",
        active: true,    
        includeInQuiz: true,
        gender: "Female",
        exclude: "Male",
        audience: "Adults",
        diet: ["Halal"],
        primary: ["Healthy Skin"],
        secondary: [
            "Healthy Joints",
            "Less Stress",
            "More Energy",
            "Staying Focussed"
        ],
        special: null
    },

    "15354465190267": {
        id: 15354465190267,
        title: "Pomegranate Cider Vinegar Gummies",
        handle:"pomegranate-cider-vinegar-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["Better Digestion"],
        secondary: [
            "Beautiful Hair",
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

     "8900439703784": {
        id: 8900439703784,
        title: "PruneAid Prune Concentrate",
        handle: "prune-juice",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["Better Digestion"],
        secondary: [
            "Healthy Joints",
            "Less Stress"
        ],
        special: {       
            digestion: window.Wellgard.Constants.SYMPTOMS.CONSTIPATED,
            score: 10
        }
    },

    "3670667067466": {
        id: 3670667067466,
        title: "Pure Collagen Powder",
        handle: "collagen-powder",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: ["Healthy Skin","Beautiful Hair", "Stronger Nails"],
        secondary: [],
        special: {
            featured:'true',
            score: 10
        }
    },

    "8896075071720": {
        id: 8896075071720,
        title: "RiseReady Probiotics",
        handle: "rise-ready",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "Better Digestion",
            "More Energy"
        ],
        secondary: [
            "Less Stress",
            "Staying Focussed",
            "Stronger Immunity"
        ],
        special: null
    },

    "6974294687921": {
        id: 6974294687921,
        title: "Root Ashwagandha Capsules",
        handle: "ultimate-root-ashwagandha-extract",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "Less Stress"
        ],
        secondary: [
            "Better Sleep"
        ],
        special: null
    },

    "14586087473531": {
        id: 14586087473531,
        title: "Ruby Reds Powder",
        handle: "ruby-powder",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "General Wellbeing",
            "More Energy"
        ],
        secondary: [
            "Beautiful Hair",
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "15155615072635": {
        id: 15155615072635,
        title: "Safromight for Men",
        handle: "safromight",
        active: true,    
        includeInQuiz: true,
        gender: "Male",
        exclude: "Female",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "Hormonal Health"
        ],
        secondary: [
            "Beautiful Hair",
            "Healthy Joints",
            "Healthy Skin",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "8454786351336": {
        id: 8454786351336,
        title: "Sea Moss Gummies",
        handle: "vegan-sea-moss-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "General Wellbeing"
        ],
        secondary: [
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity"
        ],
        special: null
    },

    "8906636853480": {
        id: 8906636853480,
        title: "Shilajit Gummies",
        handle: "himalayan-shilajit-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "More Energy"
        ],
        secondary: [
            "Beautiful Hair",
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "15092427227515": {
        id: 15092427227515,
        title: "Skin Fuel Capsules",
        handle: "skin-fuel",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "Healthy Skin"
        ],
        secondary: [
            "Beautiful Hair",
            "Healthy Joints",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "8941095682280": {
        id: 8941095682280,
        title: "True Silica Drops",
        handle: "wellgard-true-silica-osa",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "Beautiful Hair",
            "Stronger Nails"
        ],
        secondary: [
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity"
        ],
        special: null
    },

    "6974292885681": {
        id: 6974292885681,
        title: "Ultimate Glucosamine+",
        handle: "ultimate-vegan-glucosamine",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "Healthy Joints"
        ],
        secondary: [],
        special: null
    },

    "6974293999793": {
        id: 6974293999793,
        title: "Ultimate Multivitamin Tablets",
        handle: "ultimate-vegan-multivitamins-minerals",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "General Wellbeing"
        ],
        secondary: [
            "Beautiful Hair",
            "Better Digestion",
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "15401800925563": {
        id: 15401800925563,
        title: "Vegan Beetroot Gummies",
        handle: "vegan-beetroot-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "More Energy"
        ],
        secondary: [
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "Staying Focussed",
            "Stronger Immunity"
        ],
        special: null
    },

    "7670978805992": {
        id: 7670978805992,
        title: "Vegan Multivitamin Gummies",
        handle: "vegan-multivitamin-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "General Wellbeing"
        ],
        secondary: [
            "Beautiful Hair",
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "7956640465128": {
        id: 7956640465128,
        title: "Vegan Omega 3-6-9 Capsules",
        handle: "vegan-omega-3-6-9",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "General Wellbeing"
        ],
        secondary: [],
        special: null
    },

    "VEGAN_PROTEIN": {
        id: null,
        title: "Vegan Protein",
        handle: "",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [],
        secondary: [
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity"
        ],
        special: null
    },

    "14804861419899": {
        id: 14804861419899,
        title: "Vitaferrin Lactoferrin",
        handle: "vitaferrin",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: [],
        primary: [
            "Stronger Immunity"
        ],
        secondary: [
            "Beautiful Hair",
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Nails"
        ],
        special: null
    },

    "4463525298250": {
        id: 4463525298250,
        title: "Vitaflora Women's Probiotics",
        handle: "probiotics-for-women",
        active: true,    
        includeInQuiz: true,
        gender: "Female",
        exclude: "Male",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "Better Digestion"
        ],
        secondary: [],
        special: null
    },

    "6974290591921": {
        id: 6974290591921,
        title: "Vitamin B Complex Capsule",
        handle: "ultimate-vegan-b-complex",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "More Energy"
        ],
        secondary: [
            "Beautiful Hair",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "6974296850609": {
        id: 6974296850609,
        title: "Vitamin B12 Capsules",
        handle: "ultimate-vegan-vitamin-b12",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "More Energy"
        ],
        secondary: [
            "Healthy Joints",
            "Hormonal Health",
            "Less Stress",
            "Staying Focussed",
            "Stronger Immunity"
        ],
        special: null
    },

    "8066370273512": {
        id: 8066370273512,
        title: "Vitamin B12 Gummies",
        handle: "vegan-vitamin-b12-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "More Energy"
        ],
        secondary: [],
        special: null
    },

    "6974297768113": {
        id: 6974297768113,
        title: "Vitamin C & Zinc Capsules",
        handle: "ultimate-vegan-vitamin-c-zinc",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "Stronger Immunity"
        ],
        secondary: [
            "Beautiful Hair",
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Nails"
        ],
        special: null
    },

    "6974296228017": {
        id: 6974296228017,
        title: "Vitamin D Capsules",
        handle: "ultimate-vegan-vitamin-d",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "Stronger Immunity"
        ],
        secondary: [
            "Healthy Joints"
        ],
        special: null
    },

    "15023785902459": {
        id: 15023785902459,
        title: "Vitamin D3 & K2 Gummies",
        handle: "d3-k2-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Unisex",
        exclude: "",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "Healthy Joints"
        ],
        secondary: [],
        special: null
    },

    "15211797414267": {
        id: 15211797414267,
        title: "Women Multivit Gummies",
        handle: "female-multivitamin-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Female",
        exclude: "Male",
        audience: "Adults",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "General Wellbeing"
        ],
        secondary: [
            "Beautiful Hair",
            "Better Digestion",
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    },

    "14585818612091": {
        id: 14585818612091,
        title: "Women's Multi 50+ Gummies",
        handle: "womens-over-50s-multivitamins-gummies",
        active: true,    
        includeInQuiz: true,
        gender: "Female",
        exclude: "Male",
        audience: "50+",
        diet: ["Vegan","Vegetarian"],
        primary: [
            "General Wellbeing"
        ],
        secondary: [
            "Beautiful Hair",
            "Better Digestion",
            "Healthy Joints",
            "Healthy Skin",
            "Hormonal Health",
            "Less Stress",
            "More Energy",
            "Staying Focussed",
            "Stronger Immunity",
            "Stronger Nails"
        ],
        special: null
    }

};


console.log(
    "Wellgard Products Loaded",
    window.Wellgard.Products
);